export const MAPBOX_TILES_ROOT_URL = 'https://api.mapbox.com/v4';
